import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import externalApi from '../../api';

type EditTrackedEquipmentRequest = {
  trackedEquipmentId: string;
  notes: string;
  lastUpdatedUserId: string;
};

type EditTrackedEquipmentResponse = {
  trackedEquipmentId: number;
};

function editTrackedEquipment(
  request: EditTrackedEquipmentRequest
): Promise<EditTrackedEquipmentResponse> {
  return externalApi.patch(`TrackedEquipment/patch/notes`, { json: request }).json();
}

function useEditTrackedEquipmentNotes() {
  const queryClient = useQueryClient();
  return useMutation((request: EditTrackedEquipmentRequest) => editTrackedEquipment(request), {
    onSuccess: () => {
      queryClient.invalidateQueries(['AllTrackedEquipment']);
    },
  });
}
export { useEditTrackedEquipmentNotes };
